import { useState } from 'react'
import { nanoid } from 'nanoid'
import { Button } from 'shared/ui'
import { PresetContainer, PresetFooter } from 'shared/Preset'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { type ICallingListResponse, type IAICallingType } from 'entities/AICalling/api/types'
import { CallingContent } from 'pages/chatbot/ui/ChatbotCreate/CallingContent'
import { CreateModalContent } from './CreateModalContent'
import styles from './styles.module.scss'

export type ICallingTemplateContentProps = {
  modalId: string
  onCreated: (agent: ICallingListResponse) => void
}

export const CallingTemplateContent = ({ modalId, onCreated }: ICallingTemplateContentProps) => {
  const [selectedType, setSelectedType] = useState<IAICallingType>('custom')

  const handleCancel = () => {
    modalStore.closeModal(modalId)
  }

  const handleNext = () => {
    const createModalId = nanoid()
    modalStore.closeModal(modalId)
    modalStore.addModal({
      id: createModalId,
      title: 'New AI Calling Agent',
      pureContent: true,
      ModalContent: () => (
        <CreateModalContent type={selectedType} modalId={createModalId} onCreated={onCreated} />
      ),
      width: 508,
    })
  }

  return (
    <PresetContainer>
      <CallingContent selectedType={selectedType} onSelectType={setSelectedType} />
      <PresetFooter className={styles.footer}>
        <Button contained='secondary' size='medium' text='Cancel' onClick={handleCancel} />
        <Button typeBtn='contained' size='medium' text='Next' onClick={handleNext} />
      </PresetFooter>
    </PresetContainer>
  )
}
